import { render } from "./ForgotPasswordModal.vue?vue&type=template&id=6d2c610f&ts=true"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_4ed9b393/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__